import React from 'react';
import YetToBeImplemented from '../YetToBeImplemented/YetToBeImplemented';

function CPublishModal() {
  return (
    <div>
      <YetToBeImplemented />
    </div>
  );
}

export default CPublishModal;
